import {useEffect, useState} from 'react'

// Get dimensions of parent element
export const useParentSize = (ref: React.RefObject<HTMLElement>) => {
  const [parentSize, setParentSize] = useState<{width: number; height: number} | null>(null)

  useEffect(() => {
    if (!ref.current) return
    const element = ref.current
    const parent = element.parentElement

    if (!parent) return

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === parent) {
          setParentSize({width: entry.contentRect.width, height: entry.contentRect.height})
        }
      }
    })

    observer.observe(parent)

    return () => {
      observer.disconnect()
    }
  }, [ref])

  return parentSize
}
